import React from "react";

const ArrowRightCircle = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-arrow-right-circle"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-arrow-right-circle"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M0,12A12,12,0,1,0,12,0,12.013,12.013,0,0,0,0,12Zm22,0A10,10,0,1,1,12,2,10.011,10.011,0,0,1,22,12ZM13.121,6.293a1,1,0,0,0,0,1.414L16.413,11,6,11.007a1,1,0,1,0,0,2L16.414,13l-3.293,3.293a1,1,0,1,0,1.389,1.438l.025-.024,3.586-3.585a3,3,0,0,0,0-4.243h0L14.535,6.293A1,1,0,0,0,13.121,6.293Z" />
    </svg>
  );
};

export default ArrowRightCircle;
